import React, { Component } from "react";
import PropTypes from "prop-types";
import autobind from "autobind-decorator";
import { connect } from "react-redux";
import {
    Container,
    Row,
    Col,
    InputGroup,
    InputGroupAddon,
    Button,
    Input,
    UncontrolledTooltip,
    FormGroup,
    Label
} from 'reactstrap';

import LayoutDashboard from "../../../views/layout/Dashboard";
import {layout} from "../../../../ts-helpers/decorators";
import http from "../../../services/HttpService";

@layout(LayoutDashboard)
@(connect((state) => {
    return { };
}) as any)

export default class Home extends Component<any> {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
    };

    state = {
    };

    constructor(props: Map<any, any>) {
        super(props);
    }

    componentDidMount() {
        this.getData();
        this.props.onRef(this);
    }

    @autobind
    getData(){

    }

    render() {
        return(
            <Container fluid>
                <Row>
                    <div className="col-sm-12">
                        <h4 className="header-title m-t-0 m-b-20">Home!</h4>
                    </div>
                </Row>
                <Container>
                    <Row>
                        <Col className="text-center dashboard_home_text">
                            Welcome to the administrative section
                        </Col>
                    </Row>
                </Container>
            </Container>
        );

    }
}
